/**
 * 描述：带复选框的下拉菜单
 * 日期：2017-7-11
 * 作者：Bai.zhiming
 */
"use strict";
angular.module("util.trsSingleSelectionCheckbox", [])
    .directive("trsSingleSelectCheckbox", ["$timeout", function($timeout) {
        return {
            scope: {
                callback: "&",
                options: "=",
                selectedOptions: "=",
                placeholder: "@",
                isOpened:"="
            },
            restrict: 'E',
            templateUrl: './utils/trsDropDownList/trsSingleSelectionCheckbox_tpl.html',
            link: function(scope, iElm, iAttrs) {
                scope.isOpen = false;
                if(scope.isOpened!=undefined){
                    scope.isOpened=scope.isOpen;
                }
                scope.selectedOptions = [];
                scope.changeOpen=function(){
                    scope.isOpen = false;
                    if(scope.isOpened!=undefined){
                        scope.isOpened=scope.isOpen;
                    }
                };
                scope.setSelected = function(option) {
                    if (scope.isSelected(option)) {
                        var theOption;
                        for (var i = 0; i < scope.selectedOptions.length; i++) {
                            theOption = scope.selectedOptions[i];
                            if (theOption.value === option.value) {
                                scope.selectedOptions.splice(i, 1);
                            }
                        }
                    } else {
                        scope.selectedOptions.push(option);
                    }
                    $timeout(function() {
                        scope.callback();
                    });
                    /*scope.label = null;
                    scope.selectedOption = option;
                    scope.isOpen = false;
                    $timeout(function() {
                        scope.callback();
                    });*/
                };
                scope.isSelected = function(option) {
                    var flag = false;
                    var theOption;
                    for (var i = 0; i < scope.selectedOptions.length; i++) {
                        theOption = scope.selectedOptions[i];
                        if (theOption.value === option.value) {
                            flag = true;
                        }
                    }
                    return flag;
                };
                scope.selectAll = function() {
                    scope.selectedOptions=scope.selectedOptions.length==scope.options.length?[]:angular.copy(scope.options);
                    //scope.selectedOptions = scope.selectedOptions.length===0?angular.copy(scope.options):[];
                    $timeout(function() {
                        scope.callback();
                    });
                };
                /**
                 * [toggleDropdown description]点击展开收起
                 * @return {[type]} [description]
                 */
                scope.toggleDropdown = function() {
                    scope.isOpen = !scope.isOpen;
                    if(scope.isOpened!=undefined){
                        scope.isOpened=scope.isOpen;
                    }
                };  
            }
        };
    }]);
